import { Button } from "@bandit-network/react-ui-kit";
import { useConnect } from "@bandit-network/react-wallet-kit";
import { CheckCircledIcon, ReloadIcon } from "@radix-ui/react-icons";
import React, { useCallback, useState } from "react";
import { useQuestContext } from "../../../context/QuestContext";
import useUser from "../../../hooks/useUser";
import { Task, TaskType } from "../../../types";
import { getTarget, getUrl } from "../../../utils";
import { replaceHyperlinks } from "../../../utils/hyperlink";

export interface LikeProps {
  data: Task;
}

const Like: React.FC<LikeProps> = ({ data }) => {
  const [isVisited, setIsVisited] = useState(false);
  const { signature } = useConnect();
  const { user, onXConnect, isUserLoading, showRefresh, fetchUser } = useUser();
  const {
    questId,
    questSDK,
    address,
    isConnected,
    currentModuleId,
    tasksCompleted,
  } = useQuestContext();

  const isTaskComplete = tasksCompleted.includes(data?.id);

  const onClick = useCallback(async () => {
    try {
      setIsVisited(true);
      await questSDK.saveTwitterPerformTask({
        walletAddress: address,
        signature: signature.data,
        taskId: data?.id,
      });
      const url = getUrl(TaskType.X_LIKE, data?.args?.twitterPostId);
      setTimeout(() => {
        window.open(url, getTarget(), "height=600,width=600");
      }, 100);
      setTimeout(() => {
        setIsVisited(false);
      }, 7500);
    } catch (e) {}
  }, [address, currentModuleId, signature, questId, data]);

  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      {user?.socialmedia?.twitter ? (
        <Button
          size="sm"
          className="bad-quest__task--action_button"
          onClick={onClick}
          disabled={isTaskComplete || isVisited}
        >
          {isTaskComplete ? `Completed` : isVisited ? "Liking..." : `Like on X`}
          {isTaskComplete && (
            <CheckCircledIcon className="bad-quest__task--check_icon" />
          )}
        </Button>
      ) : (
        <div className="flex items-center">
          <Button
            size="sm"
            className="bad-quest__task--action_button"
            onClick={onXConnect}
            disabled={isTaskComplete || !signature?.data || isUserLoading}
          >
            {isUserLoading ? `Connecting...` : `Connect X`}
          </Button>
          {showRefresh && (
            <ReloadIcon
              className={`ml-2 mt-2 cursor-pointer bad-quest_action_button-reload${
                !isUserLoading ? "-stop" : ""
              }`}
              onClick={fetchUser}
            />
          )}
        </div>
      )}
    </div>
  );
};

export { Like };
